export default [
  '<main>',
  '  <div class="container">',
  '    <div class="d-flex justify-content-center align-items-center vh-100">',
  '      <div class="text-center">',
  '        <h1>Uh oh! There is no visual use case to show yet. 😞</h1>',
  '        <p>',
  '          We are working to rectify that.',
  '          <br />',
  '          However, the model is already loaded into the playground for you to get started with.',
  '        </p>',
  '      </div>',
  '    </div>',
  '  </div>',
  '</main>',
].join('\n');
